import {
  Box,
  Center,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  Grid,
  Icon,
  IconButton,
  Text,
  VStack,
} from '@chakra-ui/react'
import { Check } from 'lucide-react'
import { useQuery } from 'react-query'

import { DialogDrawer } from '@/components/shared/bundles/Drawer'
import { ImageContainer } from '@/components/shared/displayers/ImageContainer'
import {
  EquipmentVistaProduct as VistaProduct,
  Product,
} from '@/services/backend/config/entities'
import { Repository } from '@/services/repository'

interface Extended extends VistaProduct {
  Product: Product
}

interface Props {
  vistaId: string
  onSelect: (data: Extended) => void
}

export const SelectVistaProductDialog = ({ vistaId, onSelect }: Props) => {
  const { data } = useQuery(
    ['SelectVistaProductDialog', { vistaId }],
    async () => {
      const vista = await Repository.Entity.Vista.FindById({ vistaId })
      const products = await Repository.Entity.VistaProduct.FindByVistaId({
        vistaId,
      })

      products.sort((a, b) => (a.vistaIndex > b.vistaIndex ? 1 : -1))

      return { vista, products }
    },
  )

  return (
    <DialogDrawer size="md">
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>
          <Text mb={8}>Adicione um produto</Text>
          <VStack>
            <ImageContainer src={data?.vista.imageStr ?? undefined} size="xs" />
            <Text
              textAlign="center"
              fontFamily="body"
              fontWeight="normal"
              fontSize="sm"
            >
              {data?.vista.name}
            </Text>
          </VStack>
        </DrawerHeader>
        <DrawerBody>
          {data?.products.map((ea) => {
            return (
              <Grid key={ea.id} templateColumns="auto 1fr auto" gap={4} mb={8}>
                <Center>
                  <Center
                    border="1px solid"
                    borderColor="gray.400"
                    borderRadius="md"
                    minW={8}
                    h={8}
                  >
                    <Text fontSize="sm" fontWeight="bold">
                      {ea.vistaIndex + 1}
                    </Text>
                  </Center>
                </Center>

                <Box display="grid">
                  <Text fontWeight="bold" fontSize="xs">
                    {ea.Product.sku}
                  </Text>
                  <Text
                    textOverflow="ellipsis"
                    overflow="hidden"
                    whiteSpace="nowrap"
                  >
                    {ea.Product.name}
                  </Text>
                </Box>

                <Center>
                  <IconButton
                    aria-label="Selecionar"
                    icon={<Icon as={Check} />}
                    colorScheme="primary"
                    onClick={() => onSelect(ea)}
                  />
                </Center>
              </Grid>
            )
          })}
        </DrawerBody>
      </DrawerContent>
    </DialogDrawer>
  )
}
